/* eslint-disable */
import './PlanCard.css';

import { Card, CardContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fullImagePath } from '../../b2b-common/helpers';
import { AreasAndIndicatorsFromPlan, calculateTimeProgress, PlanAccessLevel, PlanSituation } from './helper';
import MoreButton from '../../b2b-common/MoreButton';
import { AutoStories, DeleteOutline, Edit, MoreVert } from '@mui/icons-material';
import ConfirmationDialog from '../../b2b-common/ConfirmationDialog';
import LogbookModalFactory from '../../b2b-logbook/forms/LogbookModalFactory';
import DatesRangeFactory from './dates/DatesRangeFactory';
import ProgressFactory from './progress/ProgressFactory';
import StatusTrendFactory from './status-trend/StatusTrendFactory';
import usePlanStatusTrendProgressData from '../hooks/usePlanStatusTrendProgressData';
import usePlansFrameworks from '../hooks/usePlansFrameworks';
import { FwRelated } from './FwsRelated';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const PlanCard = ({ plan: planData, showMoreButton = true, selectedUUIDs = [], showSituation = false, showAccessLevel = false,
    datesRangeType = 'SHORT',     
    onEdit, onDelete, onAccess }) => {

    const { t } = useB2BTranslation('b2b-plans');

    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [showLogbookModal, setShowLogbookModal] = useState(false);
    const [cardHovered, setCardHovered] = useState(false);

    const { planStatusTrendProgressData } = usePlanStatusTrendProgressData(planData.plan.planUUID);
    const { genericFwsRelated } = usePlansFrameworks(planData?.plan.planUUID, [{ frameworkSuite: 'generic', fwIds: [2] }]);
    const [sdgs2030, setSdgs2030] = useState(null);

    useEffect(() => {
        if (planData && genericFwsRelated && genericFwsRelated.length == 1 && genericFwsRelated[0].level1sDTOs.length > 0) {
            setSdgs2030(genericFwsRelated[0]);
        } else {
            setSdgs2030(null);
        }
    }, [genericFwsRelated]);

    const handleClickOnCard = () => {
        //console.log('PlanCard handleClickOnCard:', planData.plan.planUUID);
        onAccess && onAccess(planData.plan);
    }

    const handleEditPlan = () => {
        //console.log('PlanCard handleEditPlan:', planData.plan.planUUID);
        onEdit && onEdit(planData.plan);
    }

    const handleDeletePlanConfirmation = () => {
        //console.log('PlanCard handleDeletePlanConfirmation:', planData.plan.planUUID);
        onDelete && onDelete(planData.plan);
    }

    const isSelected = selectedUUIDs.includes(planData.plan.planUUID);
    const status = planStatusTrendProgressData ? planStatusTrendProgressData.status : 
        planData.statusTrendProgressData ? planData.statusTrendProgressData.status : "NO_STATUS";
    const trend = planStatusTrendProgressData ? planStatusTrendProgressData.trend :
        planData.statusTrendProgressData ? planData.statusTrendProgressData.trend : "NO_TREND";
    return (
        <Card variant='outlined' 
            onMouseEnter={() => setCardHovered(true)}
            onMouseLeave={() => setCardHovered(false)}
            className={`plan-card${cardHovered ? ' plan-card-hovered' : ''}${isSelected ? ' plan-card-selected' : ''}`}
            onClick={handleClickOnCard}
        >
            <div className='plan-card-actions'>
                { cardHovered && showMoreButton && (
                <MoreButton icon={<MoreVert />}
                    buttons={[
                        {
                            label: t('Edit'),
                            icon: <Edit />,
                            rolesAllowed: ['ADMIN', 'EDITOR'],
                            onClick: handleEditPlan,
                        },
                        {
                            label: t('Logbook'),
                            icon: <AutoStories />,
                            rolesAllowed: [],
                            b2bProducts: ['B2B_LOGBOOK'],
                            confirm: false,
                            onClick: () => setShowLogbookModal(true)
                        },
                        {
                            label: t('Delete'),
                            icon: <DeleteOutline />,
                            rolesAllowed: ['ADMIN', 'EDITOR'],
                            onClick: () => setIsConfirmationOpen(true)
                        },
                    ]}
                    dropPositionAlign='right'
                    rolesAllowed={['ADMIN', 'EDITOR', 'USER']}
                    className={'jb01-more-button'}
                    />
                )}
            </div>
            <div className='plan-card-header'>
                <img src={fullImagePath(planData.plan.imagePath)} alt={planData.plan.planName} className='plan-card-image' />
                <StatusTrendFactory approach='COMBINED' status={status} trend={trend} className='plan-card-status-and-trend' />
                <div className='plan-card-other-attributes'>
                    {showSituation && (<PlanSituation plan={planData.plan} />)}
                    {showAccessLevel && (<PlanAccessLevel plan={planData.plan} />)}
                </div>
                <FwRelated
                    framework={sdgs2030} className='plan-card-sdgs'
                    showLogo={false}
                    iconsSize={24}
                />
            </div>
            <CardContent className='plan-card-content' >
                <div className='plan-card-name'>
                    {planData.plan.planName}
                </div>
                <DatesRangeFactory datesRangeType={datesRangeType} startDate={planData.plan.planStartDate} endDate={planData.plan.planEndDate} className={'plan-card-dates-range'} />
                <div className='plan-card-areas-and-indicators'>
                    <AreasAndIndicatorsFromPlan plan={planData} />
                </div>
                <ProgressFactory progressApproach='SIMPLE' targetProgress={planStatusTrendProgressData ? planStatusTrendProgressData.progress : 0}
                    timeProgress={calculateTimeProgress(planData.plan.planStartDate, planData.plan.planEndDate)} />
                <div className='plan-card-description' dangerouslySetInnerHTML={{ __html: planData.plan.planDescription }} />
            </CardContent>
            <ConfirmationDialog
                title={t('Plan Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete the selected plan?')}
                open={isConfirmationOpen}
                onClose={() => setIsConfirmationOpen(false)}
                onConfirm={handleDeletePlanConfirmation}
            />
            <LogbookModalFactory logbookRelatedEntity={planData.plan} open={showLogbookModal}
                onClose={() => { setShowLogbookModal(false) }} />
        </Card>
    );
};

export default PlanCard;